export const FASTER_REMOTE_CONFIG_SCHEMAS = {
  RANDOM_EXPERIMENT_TO_FILL_FILE: "random_experiment_to_fill_file",
};
